import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';

export default class Visitors extends AbstractFetch {
  private static readonly CURRENT_VISITOR = 'v1/visitors/current';
  private static readonly VIEWED_PRODUCTS = 'v1/visitors/{id}/views/products?page=1&per_page=8';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  /**
   * Получает ID текущего пользователя
   */
  async getCurrentVisitorId(): Promise<IResponse<{ id: number }>> {
    return this.fetch(Visitors.CURRENT_VISITOR);
  }

  /**
   * Получает список просмотренных товаров для юзера
   */
  async getViewedProducts(id: number): Promise<IResponse<any>> {
    return this.fetch(Visitors.VIEWED_PRODUCTS.replace('{id}', String(id)));
  }
}
